import { useQuery } from '@tanstack/react-query';
import { loadMembershipPlan } from './data-loaders/membership-plan-loader';
import { useParams } from 'react-router-dom';

const useMembershipPlan = (enabled: boolean = true) => {
  const { planId } = useParams();

  return useQuery({
    queryKey: ['membershipPlan', planId],
    queryFn: () => loadMembershipPlan(planId ?? ''),
    enabled: enabled && Boolean(planId),
    retry: false,
  });
};

export default useMembershipPlan;
